import { render, staticRenderFns } from "./v-embed.vue?vue&type=template&id=9af7adc2&scoped=true&"
import script from "./v-embed.vue?vue&type=script&lang=js&"
export * from "./v-embed.vue?vue&type=script&lang=js&"
import style0 from "./v-embed.vue?vue&type=style&index=0&id=9af7adc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af7adc2",
  null
  
)

export default component.exports